import Muuri from 'muuri'

export default class MasonryGrid {
  constructor(el) {
    this.el = el
    this.grid = null
    this.init()
  }

  init() {
    this.grid = new Muuri(this.el.querySelector('.masonry-grid--wrapper'), {
      items: '.item',
      layout: {
        fillGaps: true
      }
    })

    this.el.querySelectorAll('.masonry-grid--category li').forEach(li => {
      li.addEventListener('click', () => {
        this.applyFilter(li.dataset.filter)
        this.el.querySelectorAll('.masonry-grid--category li').forEach(item => item.classList.remove('is-active'))
        li.classList.add('is-active')
      })
    })

    const select = this.el.querySelector('.masonry-grid--select')
    if (select) {
      select.addEventListener('change', () => {
        this.applyFilter(select.value === '*' ? '*' : `.${select.value}`)
      })
    }
  }

  applyFilter(value) {
    if (value === '*') {
      this.grid.filter(() => true)
    } else {
      this.grid.filter(value)
    }
  }
}
